/**
 * Blue Cross brand logo.
 *
 * The mark is a dark-blue wordmark on transparency, so on the dark hero panels it
 * needs a white plate behind it to stay legible. `onDark` adds that plate.
 */
export default function Logo({ className = "h-11 w-11", onDark = false }) {
  return (
    <img
      src="/bluecross.png"
      alt="Blue Cross"
      className={`${className} object-contain shrink-0 ${
        onDark ? "bg-white rounded-xl p-1" : ""
      }`}
    />
  );
}
